import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import AppBar from '@material-ui/core/AppBar';
import Avatar from '@material-ui/core/Avatar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import { userSignOut } from '../../actions/Auth';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import LogOut from './components/logout'

import {
  BELOW_THE_HEADER,
  COLLAPSED_DRAWER,
  FIXED_DRAWER,
  HORIZONTAL_NAVIGATION,
  INSIDE_THE_HEADER
} from '../../constants/ActionTypes';
import { switchLanguage, toggleCollapsedNav } from '../../actions/Setting';
import Menu from '../../components/TopNav/Menu';
import UserInfoPopup from '../../components/UserInfo/UserInfoPopup';

import {
  signoutData,
  refreshSession,
  refreshPlayer
} from '../../actions/StancebeamAction';
class Header extends React.Component {
  onAppsSelect = () => {
    this.setState({
      apps: !this.state.apps
    })
  };
  onUserInfoSelect = () => {
    this.setState({
      userInfo: !this.state.userInfo
    })
  };
  handleRequestClose = () => {
    this.setState({
      userInfo: false,
      apps: false
    });
  };
  onToggleCollapsedNav = (e) => {
    const val = !this.props.navCollapsed;
    this.props.toggleCollapsedNav(val);
  };
  // componentDidMount() {
  // const sessionData = (JSON.parse(localStorage.getItem("sessions")))
  // if (sessionData && sessionData.length > 0) {
  //   const payload = {
  //     userId: sessionData[0].userId,
  //     date: new Date((sessionData[0].completionDate).iso)
  //   }
  //   this.props.refreshSession(payload)
  // }
  // const usr = {
  //   userId: database.User.current().id
  // }
  // if (this.props.location.pathname.includes('profile')) {
  //   this.props.refreshPlayer(usr)
  // }
  // }

  constructor() {
    super();
    this.state = {
      anchorEl: undefined,
      searchBox: false,
      userInfo: false,
    }
  }

  render() {
    const { drawerType, navigationStyle, horizontalNavPosition } = this.props;
    const drawerStyle = drawerType.includes(FIXED_DRAWER) ? 'd-block d-xl-none' : drawerType.includes(COLLAPSED_DRAWER) ? 'd-block' : 'd-none';
    return (
      <AppBar
        className={`app-main-header ${(navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === BELOW_THE_HEADER) ? 'app-main-header-top' : ''}`}>
        <Toolbar className="app-toolbar" disableGutters={false}>
          {navigationStyle === HORIZONTAL_NAVIGATION ?
            <div className="d-block d-md-none pointer mr-3" onClick={this.onToggleCollapsedNav}>
              <span className="jr-menu-icon">
                <span className="menu-icon" />
              </span>
            </div>
            :
            <IconButton className={`jr-menu-icon mr-3 ${drawerStyle}`} aria-label="Menu"
              onClick={this.onToggleCollapsedNav}>
              <span className="menu-icon" />
            </IconButton>
          }

          <Link className="app-logo mr-2 d-none d-sm-block" to="/app/dashboard">
            <img src={require("../../assets/images/logo.png")} alt="StanceBeam" title="StanceBeam" />
          </Link>

          {(navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === INSIDE_THE_HEADER) &&
            <Menu />}

          <ul className="header-notifications list-inline ml-auto">
            <span onClick={() => {
              this.handleRequestClose();
              this.props.userSignOut()
              // this.props.signoutData()
            }} >
              <LogOut />
            </span>
            {navigationStyle === HORIZONTAL_NAVIGATION &&
              <li className="list-inline-item user-nav">
                <Dropdown
                  className="quick-menu"
                  isOpen={this.state.userInfo}
                  toggle={this.onUserInfoSelect.bind(this)}>

                  <DropdownToggle
                    className="d-inline-block"
                    tag="span"
                    data-toggle="dropdown">
                    <IconButton className="icon-btn size-30">
                      <Avatar
                        alt='...'
                        src={'https://via.placeholder.com/150x150'}
                        className="size-30"
                      />
                    </IconButton>
                  </DropdownToggle>

                  <DropdownMenu right>
                    <UserInfoPopup />
                  </DropdownMenu>
                </Dropdown>
              </li>}
          </ul>

          <div className="ellipse-shape"></div>
        </Toolbar>
      </AppBar >
    );
  }

}


const mapStateToProps = ({ settings }) => {
  const { drawerType, locale, navigationStyle, horizontalNavPosition } = settings;
  return { drawerType, locale, navigationStyle, horizontalNavPosition }
};

export default withRouter(connect(mapStateToProps, {
  toggleCollapsedNav,
  switchLanguage,
  userSignOut,
  signoutData,
  refreshSession,
  refreshPlayer
})(Header));